export default{
    newsOneTitle: 'Bunga pinjaman fintech turun 50%, pemain pinjol selektif memilih calon peminjam',
    newsOneTime: "Tanggal Publis",
    newsOneRead:"Tampilan Halaman",
    newsOneSource:"Sumber artikel:",
    newsOneDetail:[
        {
            p:'Reporter: Selvi Mayasari | Editor: Yudho Winarto'
        },
        {
            p:"Senin, 25 Oktober 2021 / 06:20 WIB"
        },
        {
            p:"KONTAN.CO.ID - JAKARTA. Asosiasi Pendanaan Bersama Indonesia (AFPI) menyepakati akan memangkas batas atas maksimal tingkat bunga pinjaman online (pinjol) sampai kurang lebih 50% dari patokan bunga pinjaman harian maksimal 0,8%."
        },
        {
            p:"Artinya, bunga pinjaman nasabah akan turun menjadi 0,4% per hari. Hal tersebut sebagai upaya agar pinjaman online bisa lebih terjangkau dengan skala ekonomis, juga sebagai upaya dalam menghadapi pinjol ilegal."
        },
        {
            p:"Langkah-langkah ini dilakukan agar industri fintech menjadi lebih sehat. Sehingga masyarakat bisa membedakan mana fintech yang ilegal dan yang resmi apalagi dengan harga yang sangat kompetitif."
        },
        {
            p:"Salah satu pemain fintech P2P lending DanaRupiah mendukung keputusan tersebut. Presiden Direktur DanaRupiah Entjik S. Djafar menyatakan, dampaknya untuk pencairan pasti akan turun, karena pihaknya akan sangat konservatif dalam memilih borrower."
        },
        {
            p:'"Kita lebih banyak memilih yang existing customer, yang risikonya sudah bisa dicover,"kata Entjik kepada kontan.co.id, Minggu (24/10).'
        },
        {
            p:"Terkait masih adakah ruang untuk menurunkan bunga pinjaman, Entjik mengaku, sudah tidak ada ruang untuk bisa turun, kalau diturunkan lagi ia meyakini semua akan berhenti di bisnis ini."
        },
        {
            p:'Entjik menyebut, untuk saat ini pihaknya tidak mau agressif dalam melakukan penyaluran pinjaman, penambahan new customer juga di hindari. "Kita tetap utamakan yang existing customer, yang sudah jelas pembayarannya ataupun risikonya," ujar Entjik.'
        },
        {
            p:"Platform teknologi finansial peer-to-peer (P2P) lending PT Amartha Mikro Fintek (Amartha) juga menyatakan, mendukung kebijakan yang dapat menciptakan ekosistem bisnis sehat bagi para pelaku fintech dan masyarakat umum sebagai nasabah/konsumen."
        },
        {
            p:'"Harapannya, dengan adanya aturan yang dapat menciptakan ekosistem yang aman, nyaman, dan saling menguntungkan, masyarakat dapat menggunakan layanan fintech lebih baik lagi, sehingga inklusi keuangan dapat terus ditingkatkan," ungkap CEO dan Founder Amartha Andi Taufan Garuda Putra.'
        },
        {
            p:"Pihaknya memastikan, para borrower tidak mengalami overdebt dengan melakukan analisa yang memanfaatkan teknologi machine learning. Sehingga hasilnya lebih akurat, dan sesuai kemampuan bayar borrower."
        },
        {
            p:'"Jadi, sudah merupakan prinsip Amartha untuk menetapkan besaran bunga yang sesuai dengan kemampuan bayar para borrower, terlepas dari ada atau tidaknya peraturan baru ini," katanya.'
        },
        {
            p:"Andi menjelaskan, Amartha akan tetap menjaga kualitas pinjaman dengan memanfaatkan teknologi. Dengan mengadopsi sistem hybrid (kombinasi online dan offline), Amartha tetap optimistis dapat mempertahankan performa keuangan yang sehat."
        },
        {
            p:"Selain itu, Amartha juga memperluas kolaborasi sinergis dengan berbagai institusi seperti perbankan, untuk bersama-sama memberikan akses permodalan bagi UMKM di Indonesia."
        },
        {
            p:'"Kolaborasi dengan institusi sangat membantu Amartha untuk tetap bertumbuh dan dapat memperluas jangkauan permodalan ke lebih banyak borrower atau mitra perempuan pengusaha mikro di pedesaan," kata Andi.'
        },
        
    ]
}